import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import { LuAlarmClock } from "react-icons/lu";
import EventFinished from "src/components/EventFinished";

const GPFreePlay2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <GPFreePlay2025Div>
      <EventFinished scheduleKeyName="gpFreePlay2025" eventType="promotion" />
      <Hero
        bgImage="promotions/gaming-machines/gp-free-play-2025/GP-Free-Play-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={`promotions/gaming-machines/gp-free-play-2025/GP-Free-Play-logo-2400x2400px-${i18n.language}.png`}
        imageAlt={t("gpFreePlay2025.hero.title")}
        darkenBg={0.5}
        showArrow
        arrowBounce
        // title={t("gpFreePlay2025.hero.title")}
        // descriptionBgColor="#0000004d"
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("gpFreePlay2025.content.subtitle")}
            text={t("gpFreePlay2025.content.text")}
          />
          <Row className="g-4 mb-0 mt-0 align-items-center" id="">
            <Col className="mt-0 text-box p-3 mb-4" xs={12} md={12}>
              <ReactMarkdown className="desc">
                {t("gpFreePlay2025.content.description")}
              </ReactMarkdown>
            </Col>
          </Row>
          <Row className="periods pb-3">
            <Col>
              <LuAlarmClock />
              <TitleSection
                as={"h3"}
                title={t("gpFreePlay2025.content.giveawayPeriods.title")}
                text={t("gpFreePlay2025.content.giveawayPeriods.text")}
                className="py-0"
              />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
    </GPFreePlay2025Div>
  );
};

const GPFreePlay2025Div = styled.div`
  width: 100%;
  height: auto;
  /* min-height: 100vh; */
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_text_container {
    /* display: none; */
  }
  .hero_image {
    opacity: 0.9;
    margin: -2rem 0;
  }
  .small {
    text-align: center;
  }
  strong {
    color: #7bfff9;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background-color: var(--lightblack);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  ul {
    list-style: none;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
    }
  }
  .text-box {
    background-color: #2c363b;
    border-radius: 10px;
  }
  p {
    font-size: 1.22rem;
    text-align: center;
  }
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
  div.periods {
    text-align: center;
    svg {
      margin: 20px 0 10px;
      color: var(--red);
      font-size: 40px;
    }
  }
`;

export default GPFreePlay2025;
